import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  structuredData?: object;
}
const SEO = ({
  title,
  description,
  canonicalUrl,
  ogImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/6enBba7nGTipGJpvGovp6X/IMG_1828.jpg',
  ogType = 'website',
  structuredData
}: SEOProps) => {
  const siteUrl = 'https://legacylabfinancial.com';
  const fullTitle = `${title} | Legacy Lab Financial`;
  return <Helmet data-id="element-382">
      <title data-id="element-383">{fullTitle}</title>
      <meta name="description" content={description} data-id="element-384" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} data-id="element-385" />}
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-386" />
      <meta property="og:title" content={fullTitle} data-id="element-387" />
      <meta property="og:description" content={description} data-id="element-388" />
      <meta property="og:image" content={ogImage} data-id="element-389" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-390" />
      <meta name="twitter:title" content={fullTitle} data-id="element-391" />
      <meta name="twitter:description" content={description} data-id="element-392" />
      <meta name="twitter:image" content={ogImage} data-id="element-393" />
      {/* Structured Data */}
      {structuredData && <script type="application/ld+json" data-id="element-394">
          {JSON.stringify(structuredData)}
        </script>}
    </Helmet>;
};
export default SEO;